import React from "react";

export const Jumbotron = ({children}) => {
    return (
        <div style={{display: "flex", justifyContent: "center", height: "100%", alignItems: "center"}}>
            <h1>{children}</h1>
        </div>
    )
}
